// The "Copy instructions" button must emit exactly the asset file's text, so
// it is bundled straight from there rather than duplicated in code.
import classChatPrompt from '../../assets/class-chat-prompt.txt?raw';

export const CLASS_CHAT_PROMPT: string = classChatPrompt;
